module.exports = __webpack_public_path__ + "static/media/lemonade@2x.13812b7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/companies/lemonade@2x.png
// module id = 76
// module chunks = 0